export default {
    namespaced: true,
    state: {
        name: "", //用户名
        term: "", //期限
        num: 5134091, //数据总量
    },
    mutations: {
        changeName(state, payload) {
            state.name = payload;
            localStorage.setItem('name', payload);
        },
        changeTerm(state, payload) {
            state.term = payload;
            localStorage.setItem('term', payload);
        },
        changeNum(state, payload) {
            state.num = payload;
            localStorage.setItem('allnum', payload);
        },
    }
}